import React from 'react'
import {ChevronLeftIcon} from "@heroicons/react/24/solid";
import {Link} from "react-router-dom";

const ShowProductLink = ({product}) => {

    return (
        <>
            <a href={product?.onlineStoreUrl} target="_blank"
               className={"text-blue-500 underline"}>
                <span className="">{product?.id}</span>
            </a>
        </>
    )
}

export default ShowProductLink
